
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industries/chemical/products/quality-control-and-assurance-software-for-chemical-manufacturing",
      function () {
        return require("private-next-pages/industries/chemical/products/quality-control-and-assurance-software-for-chemical-manufacturing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industries/chemical/products/quality-control-and-assurance-software-for-chemical-manufacturing"])
      });
    }
  